import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { chkLength as chkLengthUtil } from "../utils/format-util";
import * as moment from "moment-timezone";

@Component({
  selector: "app-calls-using-schedmed",
  templateUrl: "./calls-using-schedmed.component.html",
})
export class CallsUsingSchedmedComponent implements OnInit {
  constructor(private appservice: AppService) {}

  successMessage: any = "";
  errorMessage: any = "";
  pageNumber = 1;
  pageRecord = 10;
  norecord = false;
  callofschedmedList = [];
  count = 0;
  currentDate: any = new Date();

  ngOnInit() {
    const data = {
      pageNumber: this.pageNumber,
      pageRecord: this.pageRecord,
      tcId: localStorage.getItem("testCenterId"),
    };
    this.callofschedmed(data);
  }
  callofschedmed(data) {
    this.appservice.getCallOfSchedMed(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.callofschedmedList = res["entity"];
          this.count = res["count"];
          this.norecord = false;
        } else {
          this.norecord = true;
          this.callofschedmedList = [];
          this.count = 0;
        }
      },
      (err) => {
        this.norecord = true;
        this.callofschedmedList = [];
        this.count = 0;
      }
    );
  }
  pageChanged(event) {
    const data = {
      pageNumber: event.page,
      pageRecord: this.pageRecord,
      tcId: localStorage.getItem("testCenterId"),
    };
    this.callofschedmed(data);
  }
  convertutctolocal(value) {
    const time = value.toString().split(" ");
    const utctime = this.setLocaldatetime(value, time[0], time[1]);
    const utctime1 = this.convert24to12(utctime);
    return utctime1;
  }

  setLocaldatetime(value: any, date: any, time: any): string {
    let now_utc1 = "0";
    let local;
    if (date && time) {
      const now1 = new Date(date + " " + time);
      local = moment(now1)
        .subtract(this.currentDate.getTimezoneOffset(), "m")
        .toDate();
      now_utc1 =
        local.getFullYear() +
        "-" +
        this.chkLength(local.getMonth() + 1) +
        "-" +
        this.chkLength(local.getDate()) +
        " " +
        this.chkLength(local.getHours()) +
        ":" +
        this.chkLength(local.getMinutes()) +
        ":" +
        this.chkLength(local.getSeconds());
    }
    return now_utc1;
  }

  convert24to12(value): string {
    let timevalue = "";
    let time = value.toString().split(" ");
    // Check correct time format and split into components
    if (time && time[1]) {
      time = time[1]
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      timevalue = time.join(""); // return adjusted time or original string
    }
    return timevalue;
  }

  chkLength(data) {
    return chkLengthUtil(data);
  }
}
